import React from "react";
import {
  Button,
  ButtonGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useLanguage } from "../../contexts/LanguageContext";

const LanguageSwitcher = ({ variant = "default", showLabel = true }) => {
  const { language, setLanguage } = useLanguage();
  const [dropdownOpen, setDropdownOpen] = React.useState(false);

  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    // Force a page reload to update all components
    // Alternatively, you can use state management to trigger re-renders
    // window.location.reload();
  };

  const currentLanguageName = language === "sq" ? "Shqip" : "English";
  const currentLanguageFlag = language === "sq" ? "🇦🇱" : "🇬🇧";

  if (variant === "dropdown") {
    return (
      <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
        <DropdownToggle caret color="default" size="sm">
          {currentLanguageFlag} {showLabel && currentLanguageName}
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem
            onClick={() => handleLanguageChange("sq")}
            active={language === "sq"}
          >
            🇦🇱 Shqip
          </DropdownItem>
          <DropdownItem
            onClick={() => handleLanguageChange("en")}
            active={language === "en"}
          >
            🇬🇧 English
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  }

  // Button group variant (default)
  return (
    <ButtonGroup size="sm">
      <Button
        color={language === "sq" ? "primary" : "default"}
        onClick={() => handleLanguageChange("sq")}
        active={language === "sq"}
      >
        🇦🇱 {showLabel && "Shqip"}
      </Button>
      <Button
        color={language === "en" ? "primary" : "default"}
        onClick={() => handleLanguageChange("en")}
        active={language === "en"}
      >
        🇬🇧 {showLabel && "English"}
      </Button>
    </ButtonGroup>
  );
};

export default LanguageSwitcher;
